import { Button, CardMedia, Paper, Stack, Typography } from '@mui/material';
import { useGetProductFamilyImageQuery, useGetProductImageQuery, useUploadProductImageMutation } from '../features/products/skuImageSlice';
import Loading from './Loading';
import no_images from '../images/no_images@2x.png';
import DropArea from './DropArea';
import { capitalized } from '../helpers/strings';
import { useCallback, useState } from 'react';

const ProductImageView = ({product, side="front", width=400, height=null, nolabel=false, nocard=false, purpose="", fit="cover"}) => {
    const {data: image, error, isLoading } = useGetProductImageQuery({sku_id: product.id, side: side, width: width}, {skip: (side==="front" && product.front_template === null) || (side==="back" && product.back_template === null)})
    const [uploadProductImage, {isLoadingUpdate: isUploading }] = useUploadProductImageMutation();
    const uploadImage = useCallback((files) => {
        let file = files[0];
        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          const binaryStr = reader.result
          uploadProductImage({sku_id: product.id, purpose: purpose, data: binaryStr})
        }
        reader.readAsArrayBuffer(file)
    });

    if (isLoading) {
        return <Loading />;
    }
    if (error) {
        return <div>Error: {error}</div>
    }
    let label = []
    if (!nolabel) {
        label.push(<Typography key="label" variant="h6" marginBottom={0}>{capitalized(side)}</Typography>);
    }

    let imgelement = []
    let actions = []
    if(image) {
        if (height === null) {
            if (width === null) {
                imgelement.push(<img key="image" src={image} alt="Preview" style={{borderRadius: 4}} />)
            } else {
                imgelement.push(<img key="image" src={image} alt="Preview" style={{borderRadius: 4, width: width}} />)
            }
        } else {
            imgelement.push(<img key="image" src={image} alt="Preview" style={{borderRadius: 4, width: width, height: height, objectFit: fit}} />)
        }
    }

    if (!nocard) {
        return <>
        <Paper style={{padding: 8}} elevation={4}>
        <Stack spacing={1}>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
                {label}
                <Stack direction="row" spacing={1}>
                {actions}
                <DropArea fileHandler={uploadImage}/>
                </Stack>
            </Stack>
            {imgelement}
        </Stack>
        </Paper>
        </>
    } else {
        return <>
            {imgelement}
        </>
    }
}

const ProductFamilyImageView = ({family_id, width=400, height=260}) => {
    const {data: image, error, isLoading } = useGetProductFamilyImageQuery({family_id: family_id, width: width})

    if (isLoading) {
        return <Loading />;
    }
    if (image === null || error) {
        return <CardMedia image={no_images} sx={{width: width, height: height}} />
    }

    return <>
        <CardMedia image={image} sx={{width: width, height: height}} />
    </>
//        <img src={image} alt="Preview" style={{borderRadius: 4, width: width, height: height, objectFit: "cover"}} />
}

export { ProductImageView, ProductFamilyImageView };
export default ProductImageView;
